var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGateio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16089 10.8503C5.03582 10.8503 3.3118 9.12629 3.3118 7.00122C3.3118 4.87616 5.03582 3.15214 7.16089 3.15214V0C3.29469 0 0.162109 3.13502 0.162109 7.00122C0.162109 10.8674 3.29469 14 7.16089 14C11.0246 14 14.1597 10.865 14.1597 7.00122H11.01C11.01 9.12873 9.28595 10.8503 7.16089 10.8503Z",
    fill: "#2354E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16064 7.00121H11.0097V3.15213H7.16064V7.00121Z",
    fill: "#17E6A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGateio);
export default __webpack_public_path__ + "static/media/gateio.dd5b9bc548fd96f66346240d4b50c688.svg";
export { ForwardRef as ReactComponent };